import { Box } from '@material-ui/core';

import { ProgressWorkflowBarAndTimeline } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/components/ConditionsAndProgress/ProgressBarAndTimeline/ProgressWorkflow/ProgressWorkflowBarAndTimeline';
import { CreditCardPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/CreditCard/_shared/entities/PaymentMethodDetail/CreditCardPaymentMethodDetailEntity';
import { Conditions } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/CreditCard/ConditionsAndProgress/Conditions/Conditions';
import { CustomPaper } from '@/components/shared/components/CustomPaper';

interface ConditionsAndProgressProps {
  paymentMethodDetailEntity: CreditCardPaymentMethodDetailEntity;
}

export const ConditionsAndProgress = ({ paymentMethodDetailEntity }: ConditionsAndProgressProps) => {
  return (
    <CustomPaper fill="paper" style={{ paddingBottom: 16 }}>
      <Conditions paymentMethodDetailEntity={paymentMethodDetailEntity} />
      <Box mt={3} />
      <ProgressWorkflowBarAndTimeline paymentMethodDetailEntity={paymentMethodDetailEntity} />
    </CustomPaper>
  );
};
